import { CONSTANTS } from "src/app/constants";
import { ITeamMission } from "../interfaces/team-mission.interface";
import { Team } from "./team.model";

export class TeamMission extends Team implements ITeamMission {
  teammissionleader: number;
  teammissionapprentice: number;
  createdOn: string;
  createdBy: string;
  changedOn: string;
  changedBy: string;

  constructor(missionTeam: ITeamMission) {
    super(missionTeam);
    Object.keys(missionTeam).map(key => this[key] = missionTeam[key]);
  }

  get lastUpdatedBy(): string {
    return this.changedBy ? this.changedBy :
              this.createdBy ? this.createdBy : '';
  }

  get lastUpdatedOn(): string {
    return this.changedOn ? this.changedOn : this.createdOn;
  }

  get isMissionLeader(): boolean {
    return this.teammissionleader === CONSTANTS.TEAM.MISSION_LEADER.YES;
  }

  get isMissionApprentice(): boolean {
    return this.teammissionapprentice === CONSTANTS.TEAM.MISSION_LEADER.YES;
  }
}